// app/javascript/controllers/form_submission_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pleaseWait"]
  static values = { privilegesHash: Object }

  connect() {
    if (this.hasPrivilegesHashValue) {
      window.privilegesHash = this.privilegesHashValue
    }
  }

  submit() {
    // Clear values from hidden selects before submitting
    this.element.querySelectorAll('.subdiv:not(:visible) select').forEach(select => {
      select.value = ''
    })

    // Hide form and show waiting message
    this.element.style.display = 'none'

    const waitingHTML = `
      <div class="center-note">
        <div class="spinner-icon"></div>
        <span>Please wait while user limits are updated...</span>
      </div>
    `

    if (this.hasPleaseWaitTarget) {
      this.pleaseWaitTarget.innerHTML = waitingHTML
    }
  }
}
